import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";

function Select({ current, children, setValue, name, className }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const clickOutTheWindow = useCallback((e) => {
    if (ref.current && e.target.closest(".select") !== ref.current) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", clickOutTheWindow);

    return () => document.removeEventListener("click", clickOutTheWindow);
  }, []);

  const itemClickHandler = (name) => {
    return (value) => {
      setValue({ target: { name, value } });
      setOpen(false);
    };
  };

  const childrens = React.Children.map(children, (child) => {
    return React.cloneElement(child, { onClick: itemClickHandler(name) });
  });

  return (
    <div
      ref={ref}
      className={classNames("select", {
        opened: open,
        [className]: !!className,
      })}
    >
      <button
        type="button"
        className="select-title"
        onClick={() => setOpen(!open)}
      >
        <span>{current}</span>
      </button>
      <ul className="select-list">{childrens}</ul>
      <input
        type="hidden"
        name={name}
        value={current}
        onChange={() => {}}
        disabled
      />
    </div>
  );
}
Select.Item = ({ item, onClick }) => (
  <li className="select-list__item" onClick={onClick.bind(null, item)}>
    <span>{item.value}</span>
  </li>
);

export default Select;
